var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.625 0.5C8.92336 0.5 9.20952 0.61853 9.42049 0.829505C9.63147 1.04048 9.75 1.32664 9.75 1.625V8H16.125C16.4233 8 16.7096 8.11853 16.9205 8.3295C17.1315 8.54048 17.25 8.82664 17.25 9.125C17.25 9.42336 17.1315 9.70952 16.9205 9.92049C16.7096 10.1315 16.4233 10.25 16.125 10.25H9.75V16.625C9.75 16.9233 9.63147 17.2096 9.42049 17.4205C9.20952 17.6315 8.92336 17.75 8.625 17.75C8.32664 17.75 8.04048 17.6315 7.8295 17.4205C7.61853 17.2096 7.5 16.9233 7.5 16.625V10.25H1.125C0.826635 10.25 0.54048 10.1315 0.329505 9.92049C0.11853 9.70952 0 9.42336 0 9.125C0 8.82664 0.11853 8.54048 0.329505 8.3295C0.54048 8.11853 0.826635 8 1.125 8H7.5V1.625C7.5 1.32664 7.61853 1.04048 7.8295 0.829505C8.04048 0.61853 8.32664 0.5 8.625 0.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.22a1ce5f121800c92967e6cd839a740e.svg";
export { ForwardRef as ReactComponent };